module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-142.0365cc98.svg";